/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';

const contents = css`
  font-size: 15px;
  line-height: 2;
`;

export const PopupContents: React.FC = (props) => {
  return <span css={contents}>{props.children}</span>;
};
